import { VoyageModel } from 'models/VoyageModel';

export enum InvoiceStatus {
    Unpaid = 'unpaid',
    Pending = 'pending',
    Paid = 'paid',
}

export type InvoiceData = {
    type: string,
    currency: string,
    dueDate: string,
    items: any[],
}

export type InvoiceModel = InvoiceData & {
    id: number,
    uuid: string,
    status: InvoiceStatus,
    payer: {
        id: number,
        type: string,
        name: string,
    },
    voyage: VoyageModel,
    number: string,
    total: number,
    totalTax: number,
    prepaid: number,
    grandTotal: number,
    paid: number,
    paidAt: string,
    notify: {
        id: number,
        name: string,
    },
    cars: string[],
    invoiceables: InvoiceableModel[],
    createdAt: string,
    bank: {
        name: string,
        branchName: string,
        accountNumber: string,
        accountHolder: string,
        swiftCode: string,
        branchAddress: string,
    }
    note: string,
}

export type InvoiceSimpleModel = {
    id: number,
    uuid: string,
    status: InvoiceStatus,
    number: string,
    dueDate: string,
    paidAt: string,
}

export type InvoiceableData = {
    name: string,
    description: string,
    quantity: number,
    price: number,
    tax: number,
}
export type InvoiceableModel = InvoiceableData & {
    id: number,
    itemId: number,
    currency: string,
    meta?: {
        freight: number,
        rate: number,
        forklift: number,
        delivery: number,
        service: number,
        vehicle_type: number,
    },
}
